import { render } from "./ClassListCard3.vue?vue&type=template&id=6b73737a&scoped=true"
import script from "./ClassListCard3.vue?vue&type=script&lang=js"
export * from "./ClassListCard3.vue?vue&type=script&lang=js"

import "./ClassListCard3.vue?vue&type=style&index=0&id=6b73737a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b73737a"]])

export default __exports__